<div class="timer" [ngStyle]="{'--length': length + 'ms'}">
    <span>{{ time }}</span>
</div>
